import React from "react";
import TopicBotWidget from "../components/TopicBotWidget";

export default function TopicBotPage() {
  return (
    <div style={{padding:"12px 16px"}}>
      <TopicBotWidget />
    </div>
  );
}
